import { FC, ReactNode } from 'react';
import styles from './FloatingPanel.module.css';

export interface Panel2DProps {
  title?: string;
  width?: string | number;
  height?: string | number;
  children?: ReactNode;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}

const Panel2D: FC<Panel2DProps> = ({ 
  title, 
  width = "100%", 
  height = "auto", 
  children,
  onClick,
  active = false,
  className = ""
}) => {
  return (
    <div 
      className={`${styles.panel2D} ${active ? styles.activePanel : ''} ${className}`}
      style={{ 
        width: typeof width === 'number' ? `${width}px` : width,
        height: typeof height === 'number' ? `${height}px` : height,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        border: `1px solid ${active ? "#00ffff" : "#00ff00"}`,
        borderRadius: "5px",
        overflow: "hidden",
        marginBottom: "20px",
        boxShadow: `0 0 15px rgba(${active ? "0, 255, 255" : "0, 255, 0"}, 0.5)`,
        cursor: onClick ? "pointer" : "default"
      }}
      onClick={onClick}
    >
      {title && (
        <div 
          style={{
            backgroundColor: active ? "rgba(0, 68, 80, 0.8)" : "rgba(0, 51, 0, 0.8)",
            padding: "10px 15px",
            borderBottom: `1px solid ${active ? "#00ffff" : "#00ff00"}`
          }}
        >
          <h3 style={{
            margin: 0,
            color: active ? "#00ffff" : "#00ff00",
            fontSize: "18px",
            fontFamily: "'VT323', monospace"
          }}>{title}</h3>
        </div>
      )}
      <div style={{ padding: "15px" }}>
        {children}
      </div>
    </div>
  );
};

export default Panel2D;